import { useState, useMemo, useCallback } from 'react';
import { useDebouncedState } from '@tecsinapse/cortex-react';
import { searchMenuByLabel } from '../utils/search.js';
import { useMenuQuery } from '../../core/hooks/use-menu-query.js';

const useMenu = () => {
  const {
    data: menu,
    isLoading,
    error
  } = useMenuQuery();
  const [searchTerm, setSearchTerm] = useState("");
  const [inputSearch, setInputSearch] = useDebouncedState("", setSearchTerm);
  const options = useMemo(() => {
    return searchMenuByLabel(menu?.menus ?? [], searchTerm);
  }, [menu, searchTerm]);
  const handleSearch = useCallback((e) => {
    setInputSearch(e.target.value);
  }, [setInputSearch]);
  return {
    options,
    inputSearch,
    handleSearch,
    isLoading,
    error
  };
};

export { useMenu };
